import { useEffect } from 'react';
import { Button } from '@onchainstudios/cryptoys-common-ui';
import { getLegionImage } from '../../utils';
import CometShrug from '../../img/zoo/CometShrug.webp';
import StatusPage from '../../components/StatusPage';

function NotFound() {
  useEffect(() => {
    document.title = 'Cryptoys - Page Not Found';
  }, []);

  return (
    <StatusPage
      waveColor="red"
      legionImage={getLegionImage('notFound') ?? CometShrug}
      contentHeading="404 Error"
      contentHeadingTag={
        <>This page no longer exists. Visit the homepage and try again.</>
      }
      buttonCont={
        <Button
          id="homeButton"
          data-testid="goto-home-button"
          size="large"
          onPress={() => {
            window.location.replace(process.env.REACT_APP_HOME_URL);
          }}
        >
          Back to Home
        </Button>
      }
    />
  );
}

export default NotFound;
